import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController, Platform } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Category } from '../../interfaces/category.model';
import { CategoriesProvider } from '../../providers/categories/categories';
import { FilterProvider } from '../../providers/filter/filter';
import { SynchroProvider } from '../../providers/synchro/synchro';
import { LoginPage } from '../login/login';
import { Storage } from '@ionic/storage';
import { AuthProvider } from '../../providers/auth/auth';
import { HelperProvider } from '../../providers/helper/helper';
import { SynchroProgress } from '../../interfaces/synchro-progress.model';
import { StorageProvider } from '../../providers/storage/storage';
import { LanguageProvider } from '../../providers/language/language';
import { Language } from '../../interfaces/language.model';
import { UserInformationProvider } from '../../providers/user-information/user-information';
import { IndicationProvider } from '../../providers/indication/indication';
import { WebserviceProvider } from '../../providers/webservice/webservice';
import { NotificationProvider } from '../../providers/notification/notification';
import { Insomnia } from '@ionic-native/insomnia';


@IonicPage()
@Component({
  selector: 'page-briefcase',
  templateUrl: 'briefcase.html',
})
export class BriefcasePage {

  categories: Category[];
  loading: any;
  startSyncDate: string;
  progress: SynchroProgress;
  selectedLanguage: Language;
  languages: Language[];
  displayAsList: boolean;
  isIosPlatform: boolean;

  constructor(
    public plt: Platform,
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController, 
    public translate: TranslateService,
    public helperService: HelperProvider,
    public filterService: FilterProvider,
    public categoriesService: CategoriesProvider,
    public userInfoService: UserInformationProvider,
    public alertCtrl: AlertController,
    public synchroService: SynchroProvider,
    public languageService: LanguageProvider,
    public storage: Storage,
    public storageService: StorageProvider,
    public indicationService: IndicationProvider,
    public insomnia: Insomnia,
    public authService: AuthProvider,
    public webservice: WebserviceProvider,
    public notificationService: NotificationProvider) {
      this.setSelectedLanguage();
      this.indicationService.resetSelectedIndication();
      // this.isIosPlatform = this.plt.is('ios'); 
      //[VP - 27/01/2021] Use custom function to detect iOS because of ionic bug: https://github.com/ionic-team/ionic-v3/issues/1104
      this.isIosPlatform = this.helperService.isIOS();
  }



  ionViewDidLoad() {
    this.categories = this.filterByParentCategories();
    this.languages = this.languageService.getAllLanguages();
  }

  ionViewWillEnter(){
    this.indicationService.resetSelectedIndication();
    this.filterService.filterAssets();
    this.setSelectedLanguage();
    this.getDisplayListView();
  }

  /* LIST VIEW */

  getDisplayListView(){
    this.storage.get("displayAsList").then(displayListView => {
      if(displayListView !== null){
        this.displayAsList = displayListView;
      } else {
        this.displayAsList = false;
      }
    });
  }

  updateListView(){
    this.displayAsList = !this.displayAsList;
    this.storage.set("displayAsList", this.displayAsList);
  }

  setSelectedLanguage(){
    this.languageService.getSelectedLang().then(selectedLanguage => {
      if(selectedLanguage == null){
        this.selectedLanguage = this.languages[0];
        this.languageService.setSelectedLang(this.selectedLanguage.LanguageCode);
      } else {
        this.selectedLanguage = this.languages.find(lang => lang.LanguageCode == selectedLanguage);
      }
    }).catch(error => this.selectedLanguage = this.languages[0]);
  }

  filterByParentCategories(){
    return this.categoriesService.filterByCategories(null);
  }

  goToBack(){
    this.navCtrl.pop();
  }

  goToRoot() {
    this.navCtrl.popToRoot();
  }

  showCheckUpdates(){
    this.translate.get(['BRIEFCASE.UPDATE_TITLE', 'BRIEFCASE.UPDATE_TEXT', 'GENERAL.YES', 'GENERAL.NO']).subscribe(text => {

      const updatePopup = this.alertCtrl.create({
        title: text["BRIEFCASE.UPDATE_TITLE"],
        message: text["BRIEFCASE.UPDATE_TEXT"],
        buttons: [
          {
            text: text["GENERAL.NO"],
            handler: data => {
              console.log('Cancel clicked');
            }
          },
          {
            text: text["GENERAL.YES"],
            handler: data => {
              this.launchSynchroProcess();
            }
          }
        ]
      });
      updatePopup.present();
    });
  }

  launchSynchroProcess(){
    this.showLoading(null);
    this.authService.ping().subscribe(response => {
      if(response){
        this.getNotifications().then(() => {
          this.checkSynchroProfil();
        });
      } else {
        this.translate.get(['ERROR.INTERNET']).subscribe(text => {
          this.displayPopupMessage("Error", text["ERROR.INTERNET"]);
        });
      }
    }, error => {
      this.translate.get(['ERROR.INTERNET']).subscribe(text => {
        this.displayPopupMessage("Error", text["ERROR.INTERNET"]);
      });
    });
  }

  getNotifications(){
    return new Promise((resolve, reject) => {
      this.storage.get("lastLoginOnlineDate").then((data) => {
        console.log("data", data);
        const lastLoginOnlineDate = data;
        this.webservice.getNotifications(lastLoginOnlineDate).subscribe(notifWS => {
          this.notificationService.updateNotifsInStorage(notifWS).then(res => {
            this.notificationService.getNotifications().then(notifs => {
              //afficher les notifs
              this.dismissLoading();
              this.notificationService.showAllNotifications().then(notifs => {
                this.showLoading(null);
                this.storage.set("lastLoginOnlineDate", this.helperService.getFullDate(2));
                resolve();
              });
            });
          });
        });
      });
    });
  }

  checkSynchroProfil(){
    this.synchroService.startSynchro().then(res => {
      const response = res;
      switch (response) {
        case 'resetUser':
          this.storage.set("syncDate", null);
          this.dismissLoading();
          this.navCtrl.setRoot(LoginPage);
        break;
        case 'startSynchro':
          this.startSynchro();
        break;
        case 'noNewContent': 
          this.dismissLoading();
          this.noNewContentAvailable();
        break;
      }
    });
  }

  startSynchro(){
    this.startSyncDate = this.helperService.getFullDate(2);

    if(this.isIosPlatform){
      this.insomnia.keepAwake();

      this.synchroService.synchroAllData().subscribe((progressData: SynchroProgress) => {
  
        this.progress = progressData;
        this.showLoadingProgress();
  
        if (this.progress.Finished) {
          this.insomnia.allowSleepAgain();
  
          if (this.progress.Error) {
  
            this.dismissLoading();
            this.showSynchroErrorPopup();
  
          } else {
            this.storageService.getAllDataFromStorage()
            .then(data => {
              
              this.synchroService.setSynchroDate(this.startSyncDate).then(() => {
                this.userInfoService.setUserInformation().then(result => {
                  this.dismissLoading();
                  this.categories = this.filterByParentCategories();
                  this.filterService.filterAssets();
                }, error => {
                  this.dismissLoading();
                  this.categories = this.filterByParentCategories();
                  this.filterService.filterAssets();
                });
              });
            });
          }
        }
      });
    } else {
      this.synchroService.synchroAllLists().then((data: any) => {
        this.storageService.getAllDataFromStorage().then(data => {
          this.synchroService.setSynchroDate(this.startSyncDate).then(() => {
            this.userInfoService.setUserInformation().then(result => {
              this.dismissLoading();
              this.categories = this.filterByParentCategories();
              this.filterService.filterAssets();
            }, error => {
              this.dismissLoading();
              this.categories = this.filterByParentCategories();
              this.filterService.filterAssets();
            });
          });
        });
      });
    }

  }

  displayPopupMessage(title, message){
    this.dismissLoading();
    const popup = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: ['OK']
    });
    popup.present();
  }

  showLoading(updateContent?: string) {
    this.translate.get(['SYNCHRO.WAIT']).subscribe(text => {
      let content = text['SYNCHRO.WAIT'];
      if(typeof this.loading == 'undefined' || this.loading == null){
        this.loading = this.loadingCtrl.create({
          content: content
        });
      }
      if(updateContent !== null){
        this.loading.setContent(updateContent);
      }
      this.loading.present();
    });
  }

  dismissLoading(){
    if(this.loading){
      this.loading.dismiss();
      this.loading = null;
    }
  }

  showLoadingProgress() {
    this.translate.get(['SYNCHRO.LOADING', 'SYNCHRO.PROGRESS', 'SYNCHRO.ON']).subscribe(text => {
      let content = '';
      if(this.progress.Total > 0){
        content = `${text['SYNCHRO.LOADING']}<br>${text['SYNCHRO.PROGRESS']} : ${this.progress.Current} ${text['SYNCHRO.ON']} ${this.progress.Total}`
      } else {
        content = `${text['SYNCHRO.LOADING']}<br>${text['SYNCHRO.PROGRESS']}`
      }
      
      if(typeof this.loading == 'undefined' || this.loading == null){
        this.loading = this.loadingCtrl.create({
          content: content
        });
      }

      if(content !== ''){
        this.loading.setContent(content);
      }

      this.loading.present();
    });
  }

  noNewContentAvailable(){
    this.translate.get(['SYNCHRO.NOCONTENT_TITLE', 'SYNCHRO.NOCONTENT_TEXT']).subscribe(text => {
      let alert = this.alertCtrl.create({
        title: text["SYNCHRO.NOCONTENT_TITLE"],
        message: text["SYNCHRO.NOCONTENT_TEXT"],
        buttons: ['OK']
      });
      alert.present();
    });
  }

  showSynchroErrorPopup(){
    //Ensure loading is dismissed
    this.dismissLoading();

    return new Promise((resolve, reject) => {
      this.translate.get(['ERROR.SYNCHRO_FAILED_TITLE','ERROR.SYNCHRO_FAILED_TEXT','GENERAL.OK']).subscribe(text => {
        let alert = this.alertCtrl.create({
          title: text['ERROR.SYNCHRO_FAILED_TITLE'],
          message: text['ERROR.SYNCHRO_FAILED_TEXT'],
          buttons: [
            {
              text: text['GENERAL.OK'],
              handler: () => {
                resolve(true);
              }
            }
          ]
        });
        alert.present();
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/briefcase/briefcase.ts